import { isGALoaded } from '../utils/Utils';

const linkAnalytics = (() => {
  const config = {
    triggers: [...document.querySelectorAll('a[href*="marknad.obo.se"]'), ...document.querySelectorAll('.js-trackerTrigger')],
  };

  const build = () => {
    // check if Google analytics is loaded
    isGALoaded().then(() => config.triggers.forEach((trigger) => {
      // send data to GA on click
      const triggerText = trigger.textContent.trim() || 'appartmentSearch';

      trigger.addEventListener('click', () => {
        // eslint-disable-next-line no-undef
        gtag('event', 'click', {
          event_category: 'External links',
          event_label: triggerText,
        });
      });
    })).catch(error => console.log(error));
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

linkAnalytics.init();
